module.exports = __webpack_public_path__ + "files/117c447dd21d2eebe0295faa29a37e3e.png";